import { hide, show, toggle } from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showDropdown(config?: Record<string, any>): void;
        hideDropdown(config?: Record<string, any>): void;
        toggleDropdown(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showDropdown = function (config: Record<string, any> = {}): void {
    show(this, config);
};

HTMLElement.prototype.hideDropdown = function (config: Record<string, any> = {}): void {
    hide(this, config);
};

HTMLElement.prototype.toggleDropdown = function (config: Record<string, any> = {}): void {
    toggle(this, config);
};
